import { render, staticRenderFns } from "./MuchMore.vue?vue&type=template&id=506fe668&scoped=true"
import script from "./MuchMore.vue?vue&type=script&lang=js"
export * from "./MuchMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506fe668",
  null
  
)

export default component.exports